/**
 * Calculates the total fat content of a product based on its ingredients.
 */
export function calculateTotalFat(product: Product): number | null {
  const { ingredients } = product;
  const hasOnlyInvalidValues = ingredients.every(checkIfHasInvalidValues);

  if (hasOnlyInvalidValues) {
    return null;
  }

  const totalFat = [...ingredients].reduce(addFat, 0);

  return Math.round(totalFat);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfHasInvalidValues(ingredient: Ingredient) {
  return typeof ingredient.totalFatG !== 'number';
}

function addFat(total: number, ingredient: Ingredient) {
  const fat =
    typeof ingredient.totalFatG === 'number' ? ingredient.totalFatG : 0;

  return total + fat;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Product = {
  ingredients: Ingredient[] | readonly Ingredient[];
};

type Ingredient = { totalFatG: number | null };
